import { c as _c } from "react/compiler-runtime";
import { AuthorHoverTooltip } from './AuthorHoverTooltip';
import { AuthorLinkTooltip } from './AuthorLinkTooltip';
import type { AuthorTooltipProps } from './types';
export type { AuthorTooltipProps };
export function AuthorTooltip(props) {
  const $ = _c(4);
  switch (props.variant) {
    case "hover":
      {
        let t0;
        if ($[0] !== props) {
          t0 = <AuthorHoverTooltip {...props} />;
          $[0] = props;
          $[1] = t0;
        } else {
          t0 = $[1];
        }
        return t0;
      }
    default:
      {
        let t0;
        if ($[2] !== props) {
          t0 = <AuthorLinkTooltip {...props} />;
          $[2] = props;
          $[3] = t0;
        } else {
          t0 = $[3];
        }
        return t0;
      }
  }
}